import { GraphQlClient, Storage } from '@intelipost-js/secure-providers';

export default {
  getInfoUser({ state }) {
    const hasIntercom = Storage.get(state.storageKey, 'session');

    if (hasIntercom) {
      return Promise.resolve(hasIntercom);
    }

    return GraphQlClient.query(`
      query{
        intercom{
          app_id
          name
          email
          phone
          user_id
          user_hash
          companies{
            id
            name
            website
            created_at
          }
          created_at
          signed_up_at
          environment
        }
      }`)
      .then(({ data: { intercom } }) => {
        if (intercom) {
          Storage.set(state.storageKey, intercom, 'session');
          return Promise.resolve(intercom);
        }
        return Promise.reject();
      })
      .catch(() => {
        Storage.remove(state.storageKey, 'session');
        return Promise.reject();
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/intercom/actions.js